module.exports = __webpack_public_path__ + "img/Accept.e688df55.svg";